import { render } from "./WelcomeBio.vue?vue&type=template&id=2352f271&scoped=true"
import script from "./WelcomeBio.vue?vue&type=script&lang=js"
export * from "./WelcomeBio.vue?vue&type=script&lang=js"

import "./WelcomeBio.vue?vue&type=style&index=0&id=2352f271&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2352f271"]])

export default __exports__